import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Route } from 'react-router-dom';
import { ServiceCatalogRouter } from './serviceCatalog';
import { ServiceRouter } from './service';
import BuisnessFunctionRouter from './buisnessFunction/BuisnessFunctionRouter';
import { Features, featureToggles } from 'infrastructure/featureToggle';

const buisnessFunctionsEnabled = Boolean(featureToggles[Features.BUISNESS_FUNCTIONS]);

const OrganizationRouter = () => {
  const { isAuthenticated } = useAuthenticationService();

  return [
    <Route path={ServiceCatalogRouter.getRouterPath()} element={<ServiceCatalogRouter />} />,
    <Route path={ServiceRouter.getRouterPath()} element={<ServiceRouter />} />,
    buisnessFunctionsEnabled && (
      <Route path={BuisnessFunctionRouter.getRouterPath()} element={<BuisnessFunctionRouter />} />
    ),
    <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />,
  ];
};

export default OrganizationRouter;
